import React from 'react';

const CoinDetails = ({ coin }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200">
      <div className="px-4 py-5 sm:px-6 border-b border-gray-200 bg-gray-50">
        <h3 className="text-lg font-medium leading-6 text-gray-900">Coin Details</h3>
      </div>
      <dl className="divide-y divide-gray-200">
        <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-5 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-500 my-auto sm:col-span-2">Coin ID</dt>
          <dd className="text-sm text-gray-900 sm:col-span-3 my-auto">
            {coin.user_coin_id || '-'}
          </dd>
        </div>

        <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-5 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-500 my-auto sm:col-span-2">PCGS #</dt>
          <dd className="text-sm text-gray-900 sm:col-span-3 my-auto">
            {coin.pcgs_number || '-'}
          </dd>
        </div>

        <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-5 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-500 my-auto sm:col-span-2">Min. Variety</dt>
          <dd className="text-sm text-gray-900 sm:col-span-3 my-auto">
            {coin.minor_variety || '-'}
          </dd>
        </div>

        <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-5 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-500 my-auto sm:col-span-2">Die Variety</dt>
          <dd className="text-sm text-gray-900 sm:col-span-3 my-auto">
            {coin.die_variety || '-'}
          </dd>
        </div>

        <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-5 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-500 my-auto sm:col-span-2">Mintage</dt>
          <dd className="text-sm text-gray-900 sm:col-span-3 my-auto">
            {coin.mintage ? (() => {
              // Find the first number in the string
              const match = String(coin.mintage).match(/(\d+)/);
              if (!match) return coin.mintage;
              
              // Get the number and its position
              const number = match[0];
              const index = String(coin.mintage).indexOf(number);
              
              // Format number with commas
              const formattedNumber = parseInt(number.replace(/,/g, '')).toLocaleString('en-US');
              
              // Return the string with the formatted number
              return String(coin.mintage).slice(0, index) + formattedNumber + String(coin.mintage).slice(index + number.length);
            })() : '-'}
          </dd>
        </div>

        <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-5 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-500 my-auto sm:col-span-2">Weight</dt>
          <dd className="text-sm text-gray-900 sm:col-span-3 my-auto">
            {coin.weight ? `${parseFloat(coin.weight)}g` : '-'}
          </dd>
        </div>

        <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-5 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-500 my-auto sm:col-span-2">Diameter</dt>
          <dd className="text-sm text-gray-900 sm:col-span-3 my-auto">
            {coin.diameter ? `${coin.diameter}mm` : '-'}
          </dd>
        </div>

        <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-5 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-500 my-auto sm:col-span-2">Edge</dt>
          <dd className="text-sm text-gray-900 sm:col-span-3 my-auto">
            {coin.edge || '-'}
          </dd>
        </div>

        <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-5 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-500 my-auto sm:col-span-2">Metal</dt>
          <dd className="text-sm text-gray-900 sm:col-span-3 my-auto">
            {coin.metal ? `${coin.metal}${coin.composition ? ` (${coin.composition}%)` : ''}` : '-'}
          </dd>
        </div>

        <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-5 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-500 my-auto sm:col-span-2">Ref. #</dt>
          <dd className="text-sm text-gray-900 sm:col-span-3 my-auto">
            {coin.reference_number || '-'}
          </dd>
        </div>

      </dl>
    </div>
  );
};

export default CoinDetails;
